<div class="tab-pane fade active show" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
  <div class="card">
    <div class="card-body">No setup information needed at this time.</div>
  </div>
  @if (calledFrom == null) {
    <div class="text-right">
      <button class="btn btn-sm btn-danger" (click)="deactivateRole()">Deactivate Role</button>
    </div>
  }
</div>
